module.exports = __webpack_public_path__ + "static/media/facebook.ae0f8410.svg";